// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"62f857499ab9687f0b2d","488":"45e9c358f1b8f1d508e9","532":"8bbf4a81c065a9b9699d","592":"5f050ba9236063cffa9b","736":"f4ce7c10fa78c25bf435"}[chunkId] + ".js";
};